export default {
      id: "open-usage",
      viewBox: "0 0 30 30",
      url: "/assets/" + "icons.svg#open",
      toString: function () {
        return this.url;
      }
    }